import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Origin, OriginsData} from "@core/services/backend/common/interface/origins";
import {OriginsApi} from "@core/services/backend/common/api/origins.api";

@Injectable()
export class OriginsService extends OriginsData {
    constructor(private api: OriginsApi) {
        super();
    }

    list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any[]> {
        return this.api.list(search, pageNumber, pageSize, orderBy);
    }

    get(id: number): Observable<Origin> {
        return this.api.get(id);
    }

    create(origin: any): Observable<Origin> {
        return this.api.add(origin);
    }

    update(origin: any): Observable<Origin> {
        return this.api.update(origin);
    }

    delete(origin: any): Observable<Origin> {
        return this.api.delete(origin);
    }
}

